var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuiteMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9771 92.8018C27.2824 83.5039 37.2005 77.7896 48.125 77.7896C59.0494 77.7896 68.9675 83.5039 76.2728 92.8018M65.0137 45.8887C65.0137 55.2161 57.4523 62.7774 48.125 62.7774C38.7976 62.7774 31.2362 55.2161 31.2362 45.8887C31.2362 36.5613 38.7976 29 48.125 29C57.4523 29 65.0137 36.5613 65.0137 45.8887Z",
    stroke: "#2D3B67",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2633 23.6684H76.2704C76.5734 23.6684 76.7266 24.0335 76.5143 24.2497L67.8341 33.0886C67.6218 33.3048 67.775 33.6698 68.078 33.6698H77.0851M79.7103 3.38428H92.8242C93.1285 3.38428 93.2811 3.75198 93.0662 3.96742L80.292 16.7747C80.0771 16.9902 80.2297 17.3579 80.534 17.3579H93.6478",
    stroke: "#2D3B67",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiteMode);
export default __webpack_public_path__ + "static/media/quite_mode.25e66e16fbb8b3aa578f659f93df7f03.svg";
export { ForwardRef as ReactComponent };